var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuesRightThing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.905 22.777a.746.746 0 00-.745.742v.665a.74.74 0 00.745.743.745.745 0 00.686-.459.739.739 0 00.055-.284v-.665a.739.739 0 00-.741-.742z",
    fill: "url(#values_right_thing_svg__paint0_linear_3701_775)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.905 7.596a.743.743 0 00.741-.738v-.67a.739.739 0 00-.741-.742.746.746 0 00-.745.743v.669a.741.741 0 00.745.738z",
    fill: "url(#values_right_thing_svg__paint1_linear_3701_775)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.373 22.637a.744.744 0 000-1.051l-1.053-1.033a.75.75 0 00-1.216.241.74.74 0 00.161.81l1.055 1.05c.14.138.33.216.526.217.2-.005.39-.09.527-.234z",
    fill: "url(#values_right_thing_svg__paint2_linear_3701_775)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.465 9.82a.742.742 0 001.05 0 .739.739 0 000-1.051l-.882-.879a.742.742 0 00-1.054 0 .739.739 0 000 1.05l.886.88z",
    fill: "url(#values_right_thing_svg__paint3_linear_3701_775)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.17 7.897l-.881.879a.742.742 0 00.527 1.268.757.757 0 00.527-.217l.882-.88a.743.743 0 10-1.054-1.05z",
    fill: "url(#values_right_thing_svg__paint4_linear_3701_775)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.462 20.553l-1.036 1.033a.742.742 0 101.05 1.05l1.054-1.05a.738.738 0 00-.247-1.214.743.743 0 00-.821.18z",
    fill: "url(#values_right_thing_svg__paint5_linear_3701_775)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.59 22.118a.744.744 0 00-1.373.567l.654 1.58a.747.747 0 00.702.455.743.743 0 00.685-1.026l-.667-1.576z",
    fill: "url(#values_right_thing_svg__paint6_linear_3701_775)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21 8.248a.75.75 0 00.988.399.744.744 0 00.404-.967l-.847-2.038a.747.747 0 00-.973-.402.744.744 0 00-.4.97l.829 2.038z",
    fill: "url(#values_right_thing_svg__paint7_linear_3701_775)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.901 8.713a.754.754 0 00.703-.459l.653-1.576a.74.74 0 00-.685-1.026.747.747 0 00-.689.46l-.653 1.575a.733.733 0 00.4.966.754.754 0 00.271.06z",
    fill: "url(#values_right_thing_svg__paint8_linear_3701_775)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.183 21.72a.747.747 0 00-.973.399l-.654 1.579a.737.737 0 00.404.966c.09.038.187.057.285.056a.744.744 0 00.703-.455l.657-1.58a.74.74 0 00-.422-.966z",
    fill: "url(#values_right_thing_svg__paint9_linear_3701_775)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M.745 15.8h.667a.746.746 0 00.745-.741.741.741 0 00-.745-.743H.745A.746.746 0 000 15.06a.741.741 0 00.745.742z",
    fill: "url(#values_right_thing_svg__paint10_linear_3701_775)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 14.316h-.668a.746.746 0 00-.745.743.741.741 0 00.745.742h.667a.746.746 0 00.745-.742.741.741 0 00-.745-.743z",
    fill: "url(#values_right_thing_svg__paint11_linear_3701_775)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.224 17.765a.743.743 0 00-.973-.402l-1.582.654a.737.737 0 00-.4.967.736.736 0 00.703.459.735.735 0 00.284-.056l1.581-.655a.74.74 0 00.387-.967z",
    fill: "url(#values_right_thing_svg__paint12_linear_3701_775)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.744 10.94a.744.744 0 00-.97-.399l-2.045.844a.744.744 0 00-.404.966.743.743 0 00.703.46.75.75 0 00.284-.057l2.045-.844a.743.743 0 00.387-.97z",
    fill: "url(#values_right_thing_svg__paint13_linear_3701_775)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 18.018l-1.582-.655a.746.746 0 00-.973.402.74.74 0 00.404.967l1.581.655a.75.75 0 00.285.056.746.746 0 00.702-.459.74.74 0 00-.418-.966z",
    fill: "url(#values_right_thing_svg__paint14_linear_3701_775)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M.662 12.1l1.582.654a.75.75 0 00.284.056.746.746 0 00.703-.458.737.737 0 00-.411-.953l-1.581-.655a.747.747 0 00-.97.403.733.733 0 00.393.953z",
    fill: "url(#values_right_thing_svg__paint15_linear_3701_775)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.296 10.016c-.984.001-1.928.391-2.624 1.084a3.699 3.699 0 00-1.09 2.614c0 3.733 5.204 6.983 5.797 7.354l.137.084a.764.764 0 00.773 0l.134-.084c.594-.35 5.797-3.607 5.797-7.354a3.698 3.698 0 00-1.09-2.614 3.723 3.723 0 00-2.624-1.084 3.717 3.717 0 00-2.603 1.05 3.72 3.72 0 00-2.607-1.05zm3.257 2.64a2.227 2.227 0 011.953-1.159c.59 0 1.157.234 1.574.65.418.415.653.979.654 1.567 0 2.592-3.82 5.253-4.835 5.918-1.802-1.145-4.827-3.649-4.827-5.918 0-.587.235-1.15.652-1.566a2.232 2.232 0 012.708-.338c.344.204.626.496.817.847a.747.747 0 001.304 0z",
    fill: "url(#values_right_thing_svg__paint16_linear_3701_775)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.969 16.214c-.942-1.05-2.895-3.215-3.243-3.852a2.245 2.245 0 01-.165-1.551 8.216 8.216 0 00-.788-4.224C29.424 4.137 26.153.004 19.351.004H11.46a.437.437 0 00-.116 0h-.053l-.084.028a.736.736 0 00-.425.686.802.802 0 00.052.245v.042a.701.701 0 00.682.428h.664c5.857.112 8.664 3.652 9.838 5.806a6.92 6.92 0 01.632 3.253 3.725 3.725 0 00.32 2.518c.351.665 1.585 2.076 3.44 4.139.2.189.356.421.453.68-.2.111-.414.196-.636.252-.11.028-.22.063-.327.105a1.69 1.69 0 00-1.054 1.113c-.098.375-.091.967.492 1.678.05.06.063.101.07.09a1.089 1.089 0 01-.453.372.745.745 0 00-.44.7.738.738 0 00.465.676.555.555 0 01.295.35.502.502 0 01-.221.165C24 23.852 23.602 24.755 24 25.876c.288.858.263 1.148.217 1.292-.112.35-.664.924-3.102.816-2.58-.109-3.714 1.537-3.963 2.451a8.926 8.926 0 00-.324 2.381c0 .161 0 .287-.02.35a.74.74 0 00.635.834h.106a.746.746 0 00.734-.64c0-.123.021-.285.031-.509a7.682 7.682 0 01.253-1.982v-.052s.408-1.457 2.46-1.37h.306c-.217.288-.381.612-.485.957a9.076 9.076 0 00-.323 2.38c0 .162 0 .288-.018.351a.74.74 0 00.636.834h.102a.743.743 0 00.734-.641c.02-.169.03-.338.032-.508 0-.669.087-1.335.256-1.982v-.053c0-.017.415-1.457 2.46-1.369h.305c-.218.287-.382.61-.484.956a8.921 8.921 0 00-.324 2.381c0 .161 0 .288-.02.35a.74.74 0 00.635.834h.102a.746.746 0 00.738-.64c0-.123.021-.285.032-.509a7.677 7.677 0 01.253-1.982v-.052s.404-1.457 2.459-1.37c.977.043 3.946.172 4.589-1.849.179-.567.112-1.208-.229-2.213-.14-.416-.084-.546.313-.742a1.645 1.645 0 001.054-1.54 1.747 1.747 0 00-.32-.929c.2-.213.343-.473.415-.756a1.535 1.535 0 00-.351-1.373.842.842 0 01-.204-.35.351.351 0 01.161-.112l.211-.067c.496-.147 1.406-.416 1.659-1.257.295-.82-.496-1.695-.752-1.982zm-9.266 8.471a1.643 1.643 0 001.055-1.54 1.747 1.747 0 00-.32-.929c.2-.213.343-.473.415-.756a1.536 1.536 0 00-.37-1.373.844.844 0 01-.203-.35.353.353 0 01.161-.112c.07-.026.14-.048.211-.067.496-.147 1.406-.416 1.659-1.257.263-.92-.527-1.796-.784-2.101-.942-1.05-2.895-3.215-3.243-3.852a2.245 2.245 0 01-.165-1.551 8.217 8.217 0 00-.787-4.224 12.739 12.739 0 00-4.353-4.678 10.905 10.905 0 013.941 1.994 10.865 10.865 0 012.822 3.392 6.834 6.834 0 01.633 3.253 3.726 3.726 0 00.32 2.518c.35.665 1.584 2.076 3.443 4.139.198.191.353.423.453.68-.2.11-.414.195-.636.252a3.13 3.13 0 00-.33.105 1.695 1.695 0 00-1.054 1.113c-.099.375-.095.967.491 1.678.05.06.067.101.07.09-.113.163-.27.292-.453.372a.734.734 0 00-.439.7.74.74 0 00.46.676.562.562 0 01.3.35.498.498 0 01-.226.165c-1.054.522-1.45 1.425-1.054 2.546.292.858.264 1.148.218 1.292-.098.319-.566.816-2.46.83.066-.123.121-.25.166-.382.179-.567.112-1.208-.229-2.213-.165-.434-.112-.564.288-.76zm7.973-6.552c-.111.029-.22.064-.327.105a1.69 1.69 0 00-1.054 1.114c-.098.374-.091.966.492 1.677.049.06.063.102.07.091a1.089 1.089 0 01-.453.371.745.745 0 00-.44.7.738.738 0 00.464.677.54.54 0 01.296.35.502.502 0 01-.222.164c-1.054.522-1.45 1.426-1.054 2.546.288.858.264 1.149.218 1.292-.102.32-.57.816-2.46.83.066-.122.12-.25.162-.381.18-.568.113-1.209-.228-2.214-.14-.416-.085-.546.316-.742a1.643 1.643 0 001.054-1.54 1.747 1.747 0 00-.323-.929 1.7 1.7 0 00.418-.756 1.546 1.546 0 00-.352-1.373.798.798 0 01-.203-.35.351.351 0 01.158-.112 2.02 2.02 0 01.214-.067c.496-.147 1.406-.416 1.655-1.257.264-.92-.523-1.796-.783-2.101-.939-1.05-2.892-3.215-3.24-3.852a2.206 2.206 0 01-.165-1.551 8.26 8.26 0 00-.79-4.224 12.663 12.663 0 00-4.336-4.671 10.906 10.906 0 013.933 1.994c1.16.925 2.119 2.077 2.816 3.385a6.92 6.92 0 01.633 3.253 3.726 3.726 0 00.32 2.518c.35.665 1.584 2.076 3.44 4.139.2.189.355.421.452.68-.215.11-.444.188-.681.234z",
    fill: "url(#values_right_thing_svg__paint17_linear_3701_775)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint0_linear_3701_775",
    x1: -0.5,
    y1: 23.809,
    x2: 36.992,
    y2: 24.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint1_linear_3701_775",
    x1: -1,
    y1: 6.479,
    x2: 36.992,
    y2: 7.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint2_linear_3701_775",
    x1: -1,
    y1: 21.554,
    x2: 36.997,
    y2: 21.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint3_linear_3701_775",
    x1: -2,
    y1: 8.852,
    x2: 36.497,
    y2: 9.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint4_linear_3701_775",
    x1: -0.5,
    y1: 8.815,
    x2: 35.997,
    y2: 9.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint5_linear_3701_775",
    x1: -0.5,
    y1: 21.583,
    x2: 36.997,
    y2: 21.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint6_linear_3701_775",
    x1: -0.5,
    y1: 23.131,
    x2: 36.992,
    y2: 23.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint7_linear_3701_775",
    x1: -1,
    y1: 6.876,
    x2: 36.491,
    y2: 7.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint8_linear_3701_775",
    x1: -1,
    y1: 7.122,
    x2: 36.492,
    y2: 7.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint9_linear_3701_775",
    x1: -0.5,
    y1: 23.189,
    x2: 36.992,
    y2: 23.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint10_linear_3701_775",
    x1: -0.936,
    y1: 15.057,
    x2: 36.999,
    y2: 15.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint11_linear_3701_775",
    x1: -1.5,
    y1: 15.029,
    x2: 36.999,
    y2: 15.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint12_linear_3701_775",
    x1: -1.121,
    y1: 18.373,
    x2: 36.999,
    y2: 18.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint13_linear_3701_775",
    x1: -1,
    y1: 11.602,
    x2: 36.499,
    y2: 11.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint14_linear_3701_775",
    x1: -1,
    y1: 18.332,
    x2: 36.999,
    y2: 18.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint15_linear_3701_775",
    x1: -1.115,
    y1: 11.748,
    x2: 35.499,
    y2: 11.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint16_linear_3701_775",
    x1: -1.9,
    y1: 15.628,
    x2: 36.998,
    y2: 15.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "values_right_thing_svg__paint17_linear_3701_775",
    x1: -1.5,
    y1: 16.329,
    x2: 36.993,
    y2: 16.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })))));
}
export default __webpack_public_path__ + "static/values_right_thing.f32b8e39.svg";
export { SvgValuesRightThing as ReactComponent };